import React, { PureComponent } from 'react';
import BasketSummary from './basketsummary';
import BasketDetails from './basketdetails';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchProduct } from '../../actions/product';
import { FetchNationality } from '../../actions/nationality';
import { FetchUpgrades } from '../../actions/upgrades';
import { currencySign, renderProductTitle } from '../../helpers/utils';
import CapacityModal from './components/capacitymodal';
import BasketDeparture from './basketdeparture';
import { ProductDetailsView, hotJarVirtualPageView } from '../../actions/analytics';
import Spinner from '../shared/spinner';
import { upgradesName } from '../../helpers/upgradesHelper';

const queryString = require('query-string');

class ProductBasket extends PureComponent {


  componentDidUpdate(prevProps, prevState) {

      const { FetchProduct, match:{params}, FetchNationality, product, FetchUpgrades, currency: {iso_currency_code} } = this.props;
      const qs = queryString.parse(window.location.search);

      // Get product data from products API
      if(this.props.currency !== prevProps.currency){
        FetchProduct(params.tourID, iso_currency_code, true, true);
        FetchNationality();

        //Get upgrade name 
        if(qs.bundle !== undefined) FetchUpgrades(params.tourID, iso_currency_code);
    
      }


      //Track product view
      if(product !== prevProps.product){
        ProductDetailsView(product.header);
        hotJarVirtualPageView('/calendar/');
      }

  }

  togglePanelSlide(slideType){

    const slide1 = document.querySelector('.basket-product .s1');
    const slide2 = document.querySelector('.basket-product .s2');

    if(slideType === 'slide1'){
      slide1.classList.remove('fadeout');
      slide2.classList.remove('fadein');
      slide2.style.display = "none";
      slide1.style.display = "block";
    }else{

      //HOTJAR TRACKING
      hotJarVirtualPageView('/sign-up/');

      slide1.classList.add('fadeout');
      slide1.style.display = "none";
      slide2.style.display = "block";
      slide2.classList.add('fadein');
    }
  }


  render() {

    const { product:{redirect, header}, match:{params}, nationality, currency, product, currentTrip:{tour_id}, processing, booking, lockout, upgrades } = this.props;
    const adultPrice = (header.prices_from === undefined) ? "" : currencySign(currency.currency_mask) + header.prices_from.adult;
    
    if(redirect){
      return <Spinner text="Loading..." loadClass="search-loading-spinner" />
    }
    else{
      return (
        <div className="basket basket-product">
          <div className="slides s1">
            <div className="row">
              <div className="column small-12">
                  <h3 className="busabout-h3 no-margin">{ header.name }</h3>
                  <p className="bold no-margin viking-text" style={{ display:upgradesName(upgrades)  === "" ? 'none': 'inline-block' }}> + { upgradesName(upgrades) }</p>
                  <p className="bold no-margin">Price from <span className="orange-text">{adultPrice}</span> per person.</p>
              </div>
            </div>
            <div className="row">
              <div className="column small-12 medium-7 large-8">
                <BasketDetails title="Trip details" basketdetailsclass=""  routeParams={params} />
              </div>
              <div className="column small-12 medium-5 large-4">
                  <BasketSummary title="Summary" basketsummaryclass="" basketType="product"/>
              </div>
            </div>

          </div>

          <div className="slides s2">
            <div className="row">
              <div className="column small-12">
                <BasketDeparture
                  headerText={renderProductTitle(product, tour_id)}
                  headerPrice={adultPrice}
                  nationality={nationality}
                  basketType="product"
                  lockout={lockout}
                  upgradesName={upgradesName(upgrades)}
                  />
              </div>
            </div>
          </div>
          <div className={`capacitymodal-container ${(processing || booking) ? 'active' : ''} `}>
            <CapacityModal basketType="product" basketAction={this.togglePanelSlide}/>
          </div>
        </div>
      );
    }
  }
}



 function mapStateToProps(state){
   return {
     currency:state.currency,
     product:state.product,
     nationality:state.nationality,
     currentTrip:state.currentBooking.trips[0],
     processing:state.currentBooking.processing,
     booking:state.currentBooking.booking,
     lockout:state.currentBooking.lockout,
     upgrades:state.upgrades.data
   }
 }

 function mapDispatchToProps(dispatch){
   return bindActionCreators({
     FetchProduct,
     FetchNationality,
     FetchUpgrades
   }, dispatch);
 }

 export default connect(mapStateToProps, mapDispatchToProps)(ProductBasket);



// WEBPACK FOOTER //
// ./src/components/basket/productbasket.js